module.exports = __webpack_public_path__ + "img/aubrydefernez.96d18050.jpeg";